import { ISearchData } from '@/hooks/useSearchData'

const normalizer = ({ roomKol, merchant, kol, product, room, ...rest }: ISearchData) => {
  // roomKol 有可能會回null
  return {
    roomKol: roomKol || [],
    merchant: merchant || [],
    kol: kol || [],
    product: product || [],
    room: room || [],
    ...rest,
  }
}

export default normalizer
